import { configs } from './configs';

export const v1 = { configs };
